import S from 's-js';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import 'core-js';

import SuperCritical from 'lib/supercritical';
import { deps } from './deps';
import { InitialDataData } from 'data/models/InitialData';

const loadInitialData = () => {
    const json = (window as any).PORTCALLINITIALDATA as InitialDataData | undefined;
    if (json) {
        const data = deps.queryCaches.bootstrap.InitialData.update1(null, json);
        deps.user(data.UserSummary());
        deps.initialDataLoaded(true);
        (window as any).PORTCALLINITIALDATA = null; // free GC
        (window as any).PORTCALLINITIALDATACALLBACK = null;
    } else {
        (window as any).PORTCALLINITIALDATACALLBACK = loadInitialData;
    }
};

loadInitialData();

deps.router.running(true);

// TH 12/21/2016 -- Global scroll to top on route changes
S.root(() => S.on(deps.router.route, () => window.scrollTo(0, 0)));

const Container = SuperCritical(() => deps.router.route()?.view ?? null);

ReactDOM.render(<Container />, document.getElementById("app"));



// WEBPACK FOOTER //
// ./apps/core/app/appstart.tsx